<style lang="less">
@media only screen and (max-height: 360px) {
	.takeout{
		.check_circular{
			display: block !important;
		}
	}
}
.takeout{
	.toidentity{
		color: #032;
	}
	.line{
		height: 1px;
		background: #f2f2f2;
	}
	.redeem_type{
		.item{
			height: auto;
			min-height: 64px;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			.label{
				-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
				box-sizing: border-box;
				padding-right: 8px;
			}
			.select{
				width: 20px;
				height: 20px;
				-webkit-box-flex: 0 0 auto; -moz-box-flex: 0 0 auto; -ms-flex: 0 0 auto; flex: 0 0 auto;
				display: -webkit-box; display:flex;
				justify-content: flex-end;
			}
		}
		h3{
			font-size: 16px;
		}
		p{
			color: rgba(0,0,0,0.4);
			font-size: 12px;
			span{
				color: #d33a2a;
			}
		}
	}
	.form_space_title{
		height: 32px;
		overflow: hidden;
		background: #f2f2f2;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		padding: 0 16px;
		h3{
			font-size: 12px;
			-webkit-box-flex: 1; -moz-box-flex: 1; -ms-flex: 1; flex: 1;
		}
		p{
			font-size: 12px;
			color: #dc2a2a;
		}
	}
}
</style>

<template>
	<!-- Main takeout 余额转入 -->
	<section class="takeout">
		<!-- <toptips :tips="identity.message" v-if="identity.status != 20">
			<slot v-if="identity.status != 20">
				<router-link  class="toidentity" to="/verify">立即验证</router-link>
			</slot>
		</toptips> -->

		<div class="form">
			<money
				title="金额"
				:price="order.amt"
				:placeholder="'最多可取出 ' + (acct.acctplus_account_info.avaliable_asset || 0) + ' 元'"
				:max="acct.acctplus_account_info.avaliable_asset"
				v-on:price="setPrice"
				:takeAll="true">
			</money>
			<div class="line"></div>
			<itembank v-on:bankSelect="bankSelect"></itembank>
		</div>

		<div class="form_space_title">
			<h3>类型</h3>
			<p @click="viewRule">取出说明</p>
		</div>
		<div class="form redeem_type">
			<div class="item" @click="select_redeem('t_0')">
				<div class="label">
					<h3>快速取出</h3>
					<p>预计 <span>2</span> 小时到账<template v-if="order_prequery.t0_redeem_day_remain_limit !== ''">，当日剩余额度 {{order_prequery.t0_redeem_day_remain_limit.Format()}} 元</template></p>
				</div>
				<div class="select">
					<check-circular :agree="order.redeem_type == 't_0'"></check-circular>
				</div>
			</div>
			<div class="item" @click="select_redeem('t_1')" v-if="order_prequery.t1_redeem_up">
				<div class="label">
					<h3>普通取出</h3>
					<p><span>{{expDate.profit}}</span>仍有收益，预计 <span>{{expDate.t_1_cash_date}}</span>到账</p>
				</div>
				<div class="select">
					<check-circular :agree="order.redeem_type == 't_1'"></check-circular>
				</div>
			</div>
		</div>

		<div class="form_space"></div>

		<div class="form">
			<div class="tips">{{tips}}</div>
		</div>

		<!-- <agreement :agree="agree" v-on:toggleAgree="toggleAgree">
			<div slot="agree">
				<span>我已阅读并同意</span>
				<router-link to="/text">《用户服务协议》</router-link>
			</div>
		</agreement> -->

		<footbtn btn-txt="立即取出" :is-on="isActive" @click.native="next"></footbtn>

	</section>
</template>

<script>
	/*
		global androidJs
		global track
	*/
	import android from '@flyme/jr/js/android.js';
	import poplist from '@flyme/jr/flyme7/component/pop-list/pop-list.vue';
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import agreement from '@flyme/jr/flyme7/component/agreement/agreement.vue';

	import toptips from '../components/toptips.vue';
	import checkCircular from '../components/check_circular.vue';
	// import agreement from '../components/agreement.vue';
	import itembank from '../components/itembank.vue';
	import money from '../components/inputmoney.vue';
	import axios from '../axios.js';
	// import config from '../config.js';
	import apis from '../apis.js';

	export default {
		data: function () {
			return {
				tips: '',
				agree: true,
				identity: {
					status: 20
				},
				order_prequery: {
					"t0_redeem_day_remain_limit": '',//快速赎回今天剩余额度
					"t1_redeem_up": true//普通赎回是否支持
				},
				bank: {
					index: -1,
					isShow: false,
					data: []
				},
				order: {
					amt: '',
					order_type: 20,
					bacc_no_i: '',
					bacc_no_l4: '',
					sys_reserved_info: {},
					app_info: '',
					redeem_type: 't_0'
				},
				billPayData: {},
				acct: {
					total_asset: 0,
					acctplus_account_info: {
						total_asset: ''
					}
				},
				expDate: {}
			};
		},
		computed: {
			isActive: function() {
				if (this.agree && this.order.amt > 0) {
					return true;
				}else{
					return false;
				}

			}
		},
		components: {
			itembank,
			poplist,
			toptips,
			footbtn,
			agreement,
			money,
			checkCircular
		},
		created: function () {
			android('startLoading', {mes: '正在加载'});
			android('setTitle', {
				title: "取出"
			});
		},
		mounted: function () {
			this.getAcct();
			this.getOrderPrequery();
			this.getExpDate();
			this.getUserInfo();
			// this.getIdentity();
			// setTimeout(function () {
			// 	android('hideLoadingDialog');
			// }, 5000);
		},
		methods: {
			getExpDate: function () {
				let _this = this;
				axios.post(apis.product_expected_date, {}).then(function(d) {
					console.log('product_expected_date', d);
					for( var i in d.value) {
						if (d.value[i]) {
							_this.expDate[i] = new Date(parseInt(d.value[i])).Format("MM 月 dd 日");
						}
					}
					_this.expDate.today = new Date().Format("MM 月 dd 日");
					_this.expDate.profit = new Date(parseInt(d.value.t_1_cash_date) - 86400000).Format("MM 月 dd 日");
				});
			},
			getAcct: function () {
				let _this = this;
				axios.post(apis.acct_query, {
					show_type: 2
				}).then(function(d) {
					console.log('acct_query', d, d.value.acctplus_account_info);
					_this.acct = d.value;
				});
			},
			getOrderPrequery: function () {
				let _this = this;
				axios.post(apis.order_prequery, {
					order_type: 20
				}).then(function(d) {
					console.log('order_prequery', d.value);
					// android('hideLoadingDialog');
					android('stopLoading', '');
					_this.order_prequery = d.value;
				});
			},
			getIdentity: function () {
				let _this = this;
				axios.post(apis.identity_img_query, {
					show_type: 1
				}).then(function(d) {
					_this.identity = d.value;
				});
			},
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, function (d) {
					_this.order.sys_reserved_info = JSON.stringify({uid: d.userId});
					_this.getPhonInfo();
				});
			},
			getPhonInfo: function () {
				let app_info = {
					sn: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'sn'})),
					imei: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'imei'})),
					mac: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'productModel'})),
					flyme_version: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'flymeVersion'})),
					app_version: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'app_v'})),
					device_model: androidJs.doAndroidActionSync('getCommonInfoSync', JSON.stringify({key: 'productModel'}))
				};
				this.order.app_info = JSON.stringify(app_info);
			},
			bankSelect: function (d) {
				this.order.bacc_no_i = d.bank_acc_no_index;
				this.order.bacc_no_l4 = d.bank_no_last4;
				this.order.acc_type = d.bank_acc_type;
				this.order.bank_name = d.bank_name;
				this.order.phone = d.phone;
			},
			select_redeem: function (val) {
				this.order.redeem_type = val;
			},
			toggleAgree: function () {
				this.agree = !this.agree;
			},
			setPrice: function (d) {
				this.order.amt = d;
			},
			next: function () {
				let _this = this;
				if (!this.isActive) {
					return;
				}
				android('showLoadingDialog', {
					mes: '正在加载'
				});
				axios.post(apis.acctplus_order_create, this.order).then(function(d) {
					console.log('acctplus_order_create', d);
					if (d.code != 200) {
						_this.tips = d.message;
						android('hideLoadingDialog');
					}else{
						if (d.value.server_vld_types.indexOf('2') > -1) {
							// 使用支付密码
							_this.prepay(d.value);
						}else {
							android('hideLoadingDialog');
							_this.$router.replace({path: '/acctplus/codepay', query: {data: JSON.stringify(d.value), app_info: _this.order.app_info, sys_reserved_info: _this.order.sys_reserved_info, isCharge: false} });
						}
					}
				});
			},
			prepay: function (d) {
				let _this = this;
				axios.post(apis.acctplus_order_prepay, {
					order_id: d.order_id,
					vld_type: 2,
					app_info: this.order.app_info
				}).then(function(data) {
					console.log('acctplus_order_prepay', data);
					if (data.code != 200) {
						_this.tips = d.message;
						android('hideLoadingDialog');
					}else{
						let payData = {
							order_id: d.order_id,
							vld_type: 2,
							vld_token: data.value.token,
							vld_req: data.value.vld_req,
							sys_reserved_info: _this.order.sys_reserved_info,
							app_info: _this.order.app_info
						};
						_this.billPayData = payData;
						_this.pwdPay(payData);
					}
				});
			},
			pwdPay: function (prepay) {
				//指纹支付
                let _this = this;

                window.G_chagre_PayPwd_check = _this.paypwd_checked;
                // window.C = _this.changeBanchCard;

				let req_data = {
					req_data_content: prepay.vld_req.pay_pwd_req,
					sign: prepay.vld_req.sign
				};

                var d ={
                    validate_scene: "ecash_charge_pwd",
                    json_param: {
                        title: '取出 ' + _this.order.amt + ' 元到 ' + _this.order.bank_name + ' ' + this.order.bacc_no_l4,
                        trade_id: JSON.stringify(req_data),
                        title_mark_text: _this.order.bank_name,
                        // title_mark_color: ""
                        title_click_callback: 'C'
                    }
                };
                androidJs.doAndroidAction("requestPwdConfirm", JSON.stringify(d), "G_chagre_PayPwd_check");

			},
			paypwd_checked: function (code, msg, value) {
				let _this = this;
				if (code === 0) {
				//验证成功
					this.orderpay(value);

				}else if(code === -1){
					console.log('cancle 动作，不做处理');
					android('hideLoadingDialog');
				}else{
					android('hideLoadingDialog');
					window.G_dialogOk = _this.dialogOk;
					android('showDialog', {
						title: '',
						message: msg,
						okCallBack: 'G_dialogOk'
					});
					// _this.$router.replace({path: '/account/result', query: _this.payData });
				}
			},
			orderpay: function (data) {
				let _this = this;
				this.billPayData.vld_data = data;
				axios.post(apis.acctplus_order_pay, this.billPayData).then(function(d) {
					console.log('acctplus_order_pay', d);
					if (d.code != 200) {
						_this.tips = d.message;
						android('hideLoadingDialog');
						track('event_acctplus_order_pay', {
							way: 'paypwd',
							result: 'faild'
						});
					}else{
						track('event_acctplus_order_pay', {
							way: 'paypwd',
							result: 'success'
						});
						_this.$router.replace({path: '/account/result', query: {pay_order_id: d.value.pay_order_id} });
					}
				});
			},
			dialogOk: function () {
			},
			viewRule: function () {
				android('startPage', {
					url: 'https://wallet.mzres.com/static/richtext/index.html?id=1529406780377',
					start_type:1,
					data:'',
					display:{
						title:'取出说明'
					}
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Acctplus_takeout.vue